import React from 'react';

import { ReactComponent as Cursor } from './svg/controls/cursor.svg';
import { ReactComponent as Hand } from './svg/controls/hand.svg';
import { ReactComponent as Sticker } from './svg/controls/sticker.svg';
import { ReactComponent as Card } from './svg/controls/card.svg';
import { ReactComponent as Settings } from './svg/controls/settings.svg';
import { ReactComponent as Arrow } from './svg/arrow.svg';
import { ReactComponent as Bold } from './svg/controls/bold.svg';
import { ReactComponent as Italic } from './svg/controls/italic.svg';
import { ReactComponent as Flip } from './svg/controls/flip.svg';
import { ReactComponent as TextAlignLeft } from './svg/controls/text-align-left.svg';
import { ReactComponent as TextAlignCenter } from './svg/controls/text-align-center.svg';
import { ReactComponent as TextAlignRight } from './svg/controls/text-align-right.svg';
import { ReactComponent as Minus } from './svg/controls/minus.svg';
import { ReactComponent as Plus } from './svg/controls/plus.svg';
type Props = {};

/**
 * Icons Component
 */
export const Icons: React.FC<Props> = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
			<symbol id="cursor">
				<Cursor />
			</symbol>
			<symbol id="hand">
				<Hand />
			</symbol>
			<symbol id="sticker">
				<Sticker />
			</symbol>
			<symbol id="card">
				<Card />
			</symbol>
			<symbol id="settings">
				<Settings />
			</symbol>
			<symbol id="arrow">
				<Arrow />
			</symbol>
			<symbol id="bold">
				<Bold />
			</symbol>
			<symbol id="italic">
				<Italic />
			</symbol>
			<symbol id="flip">
				<Flip />
			</symbol>
			<symbol id="text-align-left">
				<TextAlignLeft />
			</symbol>
			<symbol id="text-align-center">
				<TextAlignCenter />
			</symbol>
			<symbol id="text-align-right">
				<TextAlignRight />
			</symbol>
			<symbol id="minus">
				<Minus />
			</symbol>
			<symbol id="plus">
				<Plus />
			</symbol>
		</svg>
	);
};
